import { render, staticRenderFns } from "./StatementCommentAdd.vue?vue&type=template&id=e82bf358&"
import script from "./StatementCommentAdd.vue?vue&type=script&lang=js&"
export * from "./StatementCommentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports